import { render, staticRenderFns } from "./NoticesEdit.vue?vue&type=template&id=44e14496&"
import script from "./NoticesEdit.vue?vue&type=script&lang=js&"
export * from "./NoticesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports